import * as d3 from "d3";
import {colonAnnotation, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(res => {
        let links = resData
        var nodes = {};

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width)
            .attr("height", chart.height)
            .call(responsivefy)

        var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10);

        links.forEach(function (link) {
            link.source = nodes[link.source] ||
                (nodes[link.source] = {name: link.source});
            link.target = nodes[link.target] ||
                (nodes[link.target] = {name: link.target});
            link.value = +link.value;
        });

        var force = d3.forceSimulation()
            .force("link", d3.forceLink().distance(100))
            .force("charge", d3.forceManyBody(-500))
            .force("center", d3.forceCenter(chart.width / 2, chart.height / 3));

        force.nodes(d3.values(nodes)).on("tick", tick)
        force.force("link").links(links)

        // build the arrow.
        svg.append("svg:defs")
            .selectAll("marker")
            .data(["end"])      // Different link/path types can be defined here
            .enter()
            .append("svg:marker")    // This section adds in the arrows
            .attr("id", String)
            .attr("viewBox", "-0 -5 10 10")
            .attr("refX", 13)
            .attr("refY", 0)
            .attr("markerWidth", 13)
            .attr("markerHeight", 13)
            .attr("orient", "auto")
            .append("svg:path")
            .attr("d", "M0,-5L10,0L0,5");

        // add the links and the arrows
        var path = svg.append("svg:g")
            .selectAll("path")
            .data(links)
            .enter()
            .append("svg:path")
            .attr("marker-end", "url(#end)")
            .style("fill", "none")
            .style("stroke", "#666")
            .attr("stroke-width", function (d) {
                return Math.log(d.value) / 2
            });

        path.append("title")
            .data(links)
            .text(function (d) {
                return "Basket Item" + colonAnnotation + d.source.name
                    + "\n" + "Reco Item" + colonAnnotation + d.target.name
                    + "\n" + chart.x1MetricTooltip + colonAnnotation + d.value
                    + "\n" + chart.y1MetricTooltip + colonAnnotation + d.value2
            })

        // define the nodes
        var node = svg.selectAll(".node")
            .data(d3.values(nodes))
            .enter()
            .append("g")
            .attr("class", "node")

        // add the nodes
        node.append("circle")
            .data(links)
            .attr("r", function (d) {
                return Math.sqrt(d.value1);
            })
            .attr("stroke", "#fff")
            .attr("stroke-width", "1.5px")
            .data(force.nodes())
            .style("fill", (d) => {
                return metric1ColorScale(d.name);
            })
            .call(d3.drag()
                .on("start", dragstarted)
                .on("drag", dragged)
                .on("end", dragended)
            )

        // add the text
        node.append("text")
            .attr("x", 12)
            .attr("dy", ".35em")
            .attr("font-size", "11px")
            .text(function (d) {
                return d.name;
            });

        node.append("title").data(force.nodes())
            .text(function (d) {
                return d.name + colonAnnotation
            })
            .append("title")
            .data(links)
            .text(function (d) {
                return d.value1
            })

        // add the curvy lines
        function tick() {
            path.attr("d", function (d) {
                var dx = d.target.x - d.source.x,
                    dy = d.target.y - d.source.y,
                    dr = Math.sqrt(dx * dx + dy * dy);
                return "M" +
                    d.source.x + "," +
                    d.source.y + "A" +
                    dr + "," + dr + " 0 0,1 " +
                    d.target.x + "," +
                    d.target.y;
            });

            node.attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")"
            })
        }

        function dragstarted(d) {
            if (!d3.event.active) force.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) force.alphaTarget(0);
            d.fx = null;
            d.fy = null;
        }
    // });
}
